import { type ButtonProps } from '@ironhack/design-system2/components/button';
import { type ReactElement } from 'react';
import { type SetRequired } from 'type-fest';

import { Button } from '@/app/components/client/button';
import { type NavbarQuery } from '../types';

type Props = {
  data: NavbarQuery;
} & SetRequired<ButtonProps, 'id'>;

export const NavFormButtons = (props: Props): ReactElement => {
  const { data, id, ...buttonProps } = props;
  const {
    navbar: {
      button: [contactButton],
      fullApplyButton: [fullApplyButton],
    },
  } = data;

  return (
    <>
      <Button
        tracking={{ f: 'nb' }}
        {...contactButton}
        id={`${id}--contact`}
        size="s"
        {...buttonProps}
      />
      {fullApplyButton && (
        <Button
          {...fullApplyButton}
          id={`${id}--fullApply`}
          size="s"
          {...buttonProps}
        />
      )}
    </>
  );
};
